import { render, staticRenderFns } from "./menu-primary.vue?vue&type=template&id=5463321e&scoped=true"
import script from "./menu-primary.vue?vue&type=script&lang=js"
export * from "./menu-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5463321e",
  null
  
)

export default component.exports